import hasUsedAllClauseTypesInSection from './helpers/hasUsedAllClauseTypesInSection';
import ClauseSectionType from './types/ClauseSectionType';
import ClauseTypeType from '../store/schema/ClauseTypeType';
import ClauseValueType from '../store/schema/ClauseValueType';
import InboxRuleClauseType from '../store/schema/InboxRuleClauseType';
import store from '../store/store';
import { getGuid } from 'owa-guid';
import { action } from 'satcheljs/lib/legacy';

let addNewClause = action('addNewClause')(function addNewClause(
    sectionType: ClauseSectionType,
    clauseType: ClauseTypeType,
    clauseValue: ClauseValueType
) {
    // If user has maxed out on clause types (they have used every possible clause type already), then it's a no-op
    if (hasUsedAllClauseTypesInSection(sectionType)) {
        return;
    }

    let newClauseId = getGuid();

    if (sectionType == 'conditional') {
        store.inboxRulesEditState.conditionalClauseIds.push(newClauseId);
    } else if (sectionType == 'action') {
        store.inboxRulesEditState.actionClauseIds.push(newClauseId);
    } else if (sectionType == 'exception') {
        store.inboxRulesEditState.exceptionClauseIds.push(newClauseId);
    } else {
        throw new Error('Cannot add a clause id to a section that does not exists');
    }

    store.inboxRulesEditState.clauseMap.set(newClauseId, <InboxRuleClauseType>{
        clauseType: clauseType,
        clauseValue: clauseValue,
    });
});

export default addNewClause;
